import { useContext } from 'react'
import { AuthContext } from '../../../../contexts'
import { Box } from '@mui/material'
import { Link, LinkType, StyledTranslationOrText } from '../../../../components'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'

export const MobileLogoutLink = () => {
  const { logOut } = useContext(AuthContext)

  return (
    <Box alignItems="flex-start" display="flex" flexDirection="column">
      <Link onClick={logOut} href="#" type={LinkType.BASIC}>
        <Box alignItems="center" display="flex" flexDirection="row">
          <StyledTranslationOrText translationId="pages.logoutPage.label" />
          <NavigateNextIcon fontSize="large" />
        </Box>
      </Link>
    </Box>
  )
}
